import { __awaiter } from "tslib";
import { BaseService } from "../../base";
export class UserService extends BaseService() {
    static get entity() {
        return "user";
    }
    static get responseName() {
        return "user";
    }
    static getByRut(rut) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "get",
                path: `find_by_rut_user/${rut}`,
            });
        });
    }
    /**
     * @param data.name
     * @param data.apepat
     * @param data.apemat
     * @param data.rut
     * @param data.state
     * @param data.email
     * @param data.node_id
     * @param data.role_id
     */
    static getFilter(data, page) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "post",
                path: `filter?page=${page}`,
                data: data,
            });
        });
    }
    static userConfirmation(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "post",
                path: "user_confirmation",
                data: data,
                responseName: "response",
            });
        });
    }
}
